const faqs = [
  {
    q: '布丁漫画下拉式阅读是什么意思？',
    a: '布丁漫画下拉式阅读是一种无需翻页的连续阅读模式。在布丁漫画网阅读任何一部漫画时，只需向下滚动页面，所有话数会自动衔接加载，从第1话一路读到最新话，中间不需要点击"下一话"按钮，阅读体验如同刷短视频一般流畅自然。',
  },
  {
    q: '布丁漫画全集免费是真的吗？需要注册吗？',
    a: '是的，布丁漫画网提供的所有布丁漫画全集均支持免费阅读。您无需注册账号即可直接浏览全部漫画内容。布丁漫画下拉式免费看是我们的核心承诺，让每一位漫画爱好者都能零门槛享受阅读乐趣。',
  },
  {
    q: '布丁漫画网有哪些漫画类型？',
    a: '布丁漫画网覆盖韩漫、日漫、国漫三大品类，题材包括恋爱、奇幻、悬疑、热血、搞笑、都市、穿越、修仙等。目前平台收录超过20000部布丁漫画全集，并且每天都在持续增加新作品。',
  },
  {
    q: '更新频率怎么样？多久更新一次？',
    a: '布丁漫画网的热门连载作品基本保持每日更新，部分作品根据原作连载节奏每周更新。所有更新均支持布丁漫画连续阅读模式，您打开作品就能从上次看到的地方继续，新章节会自动出现在阅读流中。',
  },
  {
    q: '手机和平板上能用布丁漫画连续阅读吗？',
    a: '完全可以。布丁漫画网采用响应式设计，在手机、平板和电脑上都能完美适配。移动端的布丁漫画下拉式阅读体验经过专门优化，触屏滑动更加顺畅，还支持阅读进度自动保存，换设备也能接着看。',
  },
  {
    q: '遇到喜欢的漫画可以收藏或订阅更新提醒吗？',
    a: '目前布丁漫画网提供浏览器书签收藏方式，您可以将喜欢的作品页面加入收藏夹。我们正在开发个人书架和更新推送功能，届时布丁漫画连续阅读将与个性化订阅深度结合，敬请期待。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            常见问答
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            关于布丁漫画网和布丁漫画下拉式阅读的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqs.map((item, idx) => (
            <details
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                  <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                  <i className="ri-subtract-line text-primary-600 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}